export const userRoles = [
  { value: 'supervisor', name: 'Supervisor' },
]
